window.addEventListener("DOMContentLoaded", () => {
    (() => {
        const lightbox = document.querySelector(".lightbox_video");
        const bodyElement = document.querySelector("body");
        bodyElement.appendChild(lightbox);
        const video_preview = document.querySelector(".lightbox_video-preview");

        video_preview.addEventListener("click", () => {
            lightbox.classList.add("show");
        });
        lightbox.addEventListener("click", () => {
            lightbox.classList.remove("show");
        });
    })();
});
